import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import { ChangeLogDetailModule } from '../../change-log-detail/change-log-detail.module';
import { ChangeLogBookingInfoComponent } from './change-log-booking-info.component';
import { ChangeLogPipesModule } from '../../../pipes/change-log-pipes.module';
import { ChangeLogDetailByTypeModule } from '../../change-log-detail-by-type/change-log-detail-by-type.module';

@NgModule({
  declarations: [ChangeLogBookingInfoComponent],
  imports: [CommonModule, SharedModule, ChangeLogDetailModule, ChangeLogPipesModule, ChangeLogDetailByTypeModule],
  exports: [ChangeLogBookingInfoComponent],
})
export class ChangeLogBookingInfoModule {}
